var messages = {
  networkError: 'ネットワーク異常',
  uploadPending: 'アップロード中…',
  uploadFailed: 'アップロードに失敗しました',
  uploading: 'アップロード中',
  fileUploading: 'ファイルをアップロード中',
  uploadFile: 'ファイルをアップロード',
  clickOrDragToUpload: 'ドラッグしてアップロード',
  ctrlVToPasteImage: 'Ctrl + V でスクリーンショットを貼り付ける',
  uploadImage: '画像アップロード'
};
export default messages;